import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, putApi } from 'services/rotasp/api';
import { PATH_SGU_API } from 'services/rotasp/path';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { Types, AtualizarMotivoRequest } from './types';

// ACTIONS
import { atualizarMotivoSuccess, atualizarMotivoFailure } from './actions';

function* atualizarMotivo(request: ReducerActionRotaSP) {
	const {
		token,
		payload,
	}: { token?: string; payload: AtualizarMotivoRequest } = request;

	const body = { ...payload };

	delete body.id;

	const response: ApiResponse = yield call(
		putApi,
		token || '',
		PATH_SGU_API,
		`motivos/${payload.id}`,
		body,
	);

	if (response.status === 200) {
		yield put(atualizarMotivoSuccess(response));
	} else {
		yield put(atualizarMotivoFailure());
	}
}

export default all([takeLatest(Types.ATUALIZAR_MOTIVO, atualizarMotivo)]);
